export const scholarshipIconUrl =
  'https://d14qv6cm1t62pm.cloudfront.net/sso/scholarship-icon.png';
